import React from 'react';
import { useApp } from '../../context/AppContext';
import { Navbar } from './Navbar';
import { Sidebar } from './Sidebar';
import { MobileNav } from './MobileNav';
import { QuickNoteModal } from '../common/QuickNoteModal';
import { QuickTaskModal } from '../common/QuickTaskModal';
import { QuickHabitModal } from '../common/QuickHabitModal';
import { GlobalSearchModal } from '../common/GlobalSearchModal';
import { AppLockScreen } from '../security/AppLockScreen';
import { DashboardView } from '../dashboard/DashboardView';
import { FinanceView } from '../finance/FinanceView';
import { NotesView } from '../notes/NotesView';
import { TasksView } from '../tasks/TasksView';
import { ReportsView } from '../reports/ReportsView';
import { CalendarView } from '../calendar/CalendarView';
import { HabitsView } from '../habits/HabitsView';
import { GoalsView } from '../goals/GoalsView';
import { ResourcesView } from '../resources/ResourcesView';
import { SettingsView } from '../settings/SettingsView';

export const AppLayout: React.FC = () => {
  const { currentPage, isAppLockEnabled, isAppLocked, activeModal, setActiveModal } = useApp();

  const renderCurrentView = () => {
    switch (currentPage) {
      case 'dashboard':
        return <DashboardView />;
      case 'finance':
        return <FinanceView />;
      case 'notes':
        return <NotesView />;
      case 'tasks':
        return <TasksView />;
      case 'goals':
        return <GoalsView />;
      case 'resources':
        return <ResourcesView />;
      case 'reports':
        return <ReportsView />;
      case 'calendar':
        return <CalendarView />;
      case 'habits':
        return <HabitsView />;
      case 'settings':
        return <SettingsView />;
      default:
        return <DashboardView />;
    }
  };

  return (
    <div className="min-h-screen bg-slate-100 dark:bg-[#0b0f19] text-slate-900 dark:text-slate-100 flex flex-col selection:bg-brand-500 selection:text-white transition-colors duration-200 w-full max-w-full">
      {/* Top Navigation */}
      <Navbar />

      {/* Main Container - Full Desktop Width */}
      <div className="flex-1 flex w-full max-w-full min-w-0">
        {/* Desktop Sidebar */}
        <Sidebar />

        {/* Dynamic Page Content View */}
        <main className="flex-1 px-2.5 sm:px-4 lg:px-5 py-4 pb-28 lg:pb-8 w-full max-w-full min-w-0">
          {renderCurrentView()}
        </main>
      </div>

      {/* Mobile Bottom Navigation Bar */}
      <MobileNav />

      {/* Global Quick Action Modals */}
      <QuickNoteModal isOpen={activeModal === 'note'} onClose={() => setActiveModal(null)} />
      <QuickTaskModal isOpen={activeModal === 'task'} onClose={() => setActiveModal(null)} />
      <QuickHabitModal isOpen={activeModal === 'habit'} onClose={() => setActiveModal(null)} />

      {/* Global Search Modal (Cmd+K / Ctrl+K) */}
      <GlobalSearchModal />

      {/* App Lock Screen Overlay (4-digit PIN & Fingerprint) */}
      {isAppLockEnabled && isAppLocked && <AppLockScreen />}
    </div>
  );
};
